<template>
    <div class="basic messages">
        <div class="head">{{$t('noticeInfo.tip')}}</div>
        <div class="section">
            <div style="width: 60%;">{{$t('noticeInfo.sectionTitle')}}</div>
            <div class="right">
                <div class="sectionItem timeWidth">{{$t('noticeInfo.time')}}</div>
                <div class="sectionItem">{{$t('noticeInfo.status')}}</div>
            </div>
        </div>
        <template v-if="noticeReqSuccessFlag">
            <ul>
                <li v-for="(item,index) in noticeDataList" :key="index">
                    <div class="item cursorPoint" @click="showDetail(item.id,index)">
                        <div class="headView">
                            <div class="title">
                                <i v-if="item.readFlag == 0"></i>
                                <span class="titleUnread" v-if="item.readFlag == 0">{{item.subject}}</span>
                                <span class="titleReaded" v-else>{{item.subject}}</span>
                            </div>
                            <div class="right">
                                <div class="sectionItem timeWidth">
                                    <div style="color:#999;">{{item.publishedAt|timeSwitchAll}}</div>
                                </div>

                                <div class="sectionItem">
                                    <div
                                        class="status unread"
                                        v-if="item.readFlag == 0"
                                    >{{$t('noticeInfo.unread')}}</div>
                                    <div class="status readed" v-else>{{$t('noticeInfo.readed')}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="content" v-if="selectIndex == index">{{item.content}}</div>
                    </div>
                </li>
            </ul>

            <!-- 底部 -->
            <div class="msgBottom">
                <div class="msgPagination">
                    <el-pagination
                        :current-page="currentPage"
                        :page-size="pageSize"
                        :hide-on-single-page="hidePagination"
                        layout="prev, pager, next"
                        :total="totalRecords"
                        :pager-count="5"
                        @size-change="sizeChange"
                        @current-change="currentChange"
                    ></el-pagination>
                </div>
            </div>
        </template>
        <template v-else>
            <!-- 没数据 -->
            <Nothing img="nInfoMsgIsEmpty" :title="$t('noticeInfo.msgEmpty')"></Nothing>
        </template>
    </div>
</template>
<script>
import Nothing from "../../../components/nothing/nothing";
export default {
    name: "messages",
    data() {
        return {
            currentPage: 1,
            pageSize: 6,
            totalRecords: 0,
            //只有一页时，隐藏分页器
            hidePagination: false,
            noticeDataList: [],
            isShowList: true,
            noticeDetail: {},
            noticeReqSuccessFlag: true, //公告请求有数据
            isClick: false,
            selectIndex: -1,
            noticeAllDataList: [] //所有数据
        };
    },
    props: {
        noticeItem: Object //轮播公告id
    },
    created() {
        if (this.$common.getUser()) {
            this.userId = this.$common.getUser().user_id;
        }
    },
    mounted() {
        //从其他页面打开公告详情（分页器要刷新）
        this.getNotices(this.currentPage);
    },
    filters: {
        timeSwitch(val) {
            if (val) {
                var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + ".";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + ".";
                var D =
                    date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var time = Y + M + D;
                return time;
            }
        },
        timeSwitchAll(val) {
            if (val) {
                var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "-";
                var D =
                    (date.getDate() < 10
                        ? "0" + date.getDate()
                        : date.getDate()) + " ";
                var h =
                    (date.getHours() < 10
                        ? "0" + date.getHours()
                        : date.getHours()) + ":";
                var m =
                    (date.getMinutes() < 10
                        ? "0" + date.getMinutes()
                        : date.getMinutes()) + ":";
                var s =
                    date.getSeconds() < 10
                        ? "0" + date.getSeconds()
                        : date.getSeconds();
                var time = Y + M + D + h + m + s;
                return time;
            }
        }
    },
    methods: {
        sizeChange() {},
        async getNotices(currentPage, pageSize = 6) {
            var _this = this;
            var data = {
                createdAt: "",
                currentPage: currentPage,
                pageSize: pageSize,
                publishedAt: "",
                subject: ""
            };
            var res = await _this.$http.post(_this.$api.noticeList, data, true);
            if (res.code == 0) {
                if (res.data.content.length > 0) {
                    _this.noticeReqSuccessFlag = true;
                    _this.noticeDataList = res.data.content;
                    _this.totalRecords = res.data.totalRecords;
                } else {
                    _this.noticeReqSuccessFlag = false;
                }
            } else {
                _this.noticeReqSuccessFlag = false;
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
            }
        },
        currentChange(val) {
            this.currentPage = val;
            //请求当前页的数据
            this.getNotices(this.currentPage);
        },
        async showDetail(id, index, noticeItem) {
            //显示详情
            if (this.selectIndex == index) {
                this.selectIndex = -1;
            } else {
                this.selectIndex = index;
            }
            //标记已读
            if (!noticeItem) {
                var item = this.noticeDataList.filter(function(item) {
                    return item.id == id;
                });
                if (!item[0].readFlag && this.$common.getToken()) {
                    await this.markReaded(id);
                }
            } else {
                //点击轮播公告时
                if (this.$store.state.token) {
                    //获取userId
                    if (this.$common.getUser()) {
                        this.userId = this.$common.getUser().user_id;
                    }
                    await this.markReaded(id);
                }
            }

            //显示详情
            // await this.messageDetailInter(id);
        },
        async markReaded(id) {
            //标记已读
            var _this = this;
            var messageIds = [id];
            var data = {
                content: "",
                delFlag: "",
                endAt: "",
                id: "",
                memberId: _this.userId,
                noticeIds: messageIds,
                operator: "",
                publishedAt: "",
                publishedAtType: 0,
                readFlag: 0,
                status: 0,
                subject: ""
            };
            const res = await _this.$http.post(_this.$api.readNotice, data);
            if (res.code == 0) {
                _this.noticeDataList.map(function(item) {
                    messageIds.map(function(it) {
                        if (item.id == it) {
                            item.readFlag = 1;
                        }
                    });
                });

                // _this.$message.success("公告已读成功!");
                //已读后，更新myPage页面的已读标志
                this.$store.commit("updateUnRead", "notice");
            } else {
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
            }
        },
        async messageDetailInter(id) {
            //公告详情
            this.isShowList = false;
            let _this = this;
            let data = id;
            const res = await _this.$http.get(
                _this.$api.noticeInfo,
                data,
                true
            );
            if (res.code == 0) {
                _this.noticeDetail = res.data;

                this.isClick = false;
            } else {
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
            }
        },
        async getAllNotices(n) {
            var _this = this;
            var data = {
                createdAt: "",
                currentPage: "",
                pageSize: "",
                publishedAt: "",
                subject: ""
            };
            var res = await _this.$http.post(_this.$api.noticeList, data, true);
            if (res.code == 0) {
                _this.noticeAllDataList = res.data.content;

                if (n.urlId) {
                    //打开优惠轮播banner-公告详情
                    //求公告的索引index
                    var allIndex = _this.noticeAllDataList.findIndex(function(
                        item
                    ) {
                        return item.id == n.urlId;
                    });

                    var index = ((allIndex + 1) % 6) - 1;

                    //跳转到第几页
                    await this.currentChange(parseInt((allIndex + 1) / 6) + 1);
                    //打开对应的详情
                    await this.showDetail(n.urlId, index, n);
                } else {
                    //头部轮播公告
                    var allIndex = _this.noticeAllDataList.findIndex(function(
                        item
                    ) {
                        return item.id == n.id;
                    });

                    var index = ((allIndex + 1) % 6) - 1;
                    //跳转到第几页
                    await this.currentChange(parseInt((allIndex + 1) / 6) + 1);
                    //打开对应的详情
                    await this.showDetail(n.id, index, n);
                }

                this.$store.commit("showSwiperNoticeDetail", null);
            } else {
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
            }
        }
    },
    components: {
        Nothing
    },
    watch: {
        "$store.state.swiperNoticeItem": {
            handler(n) {
                if (n) {
                    //从其他地方跳转到公告详情
                    this.getAllNotices(n);
                }
            },
            immediate: true,
            deep: true
        }
    }
};
</script>
<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.basic {
    min-height: 6.5rem;
    position: relative;
}
.head {
    margin: 20px;
    background-color: #fff4d7;
    color: #f85a3f;
    font-size: 12px;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
}
.section {
    margin: 20px;
    background-color: #f7f7f7;
    color: #666;
    font-size: 12px;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    display: flex;
    flex-direction: row;
}

.item {
    margin: 20px;
    display: flex;
    border-bottom: 1px solid #f5f5f5;
    flex-direction: column;
    padding-bottom: 20px;
}
.headView {
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
        margin-right: 10px;
        width: 25px;
        height: 30px;
    }
}
.right {
    width: 40%;
    display: flex;
    justify-content: space-between;
}
.title {
    margin: 10px;
    margin-left: 0px;
    font-size: 15px;
    font-weight: 500;
    width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 0.3rem;
    position: relative;
}
.title i {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0.1rem;
    width: 0.06rem;
    height: 0.06rem;
    border-radius: 0.03rem;
    background-color: #ff3a2b;
}
.title .titleUnread {
    color: #313131;
}
.title .titleReaded {
    color: #999;
}
.sectionItem {
    width: 33%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
.timeWidth {
    width: 40%;
}
.status {
    height: 20px;
    width: 50px;
    border-radius: 10px;
    color: #fff;
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
}
.unread {
    background-color: #ff3a2b;
}
.readed {
    background-color: #d9dde1;
}

.content {
    color: #999;
    margin: 10px;
    background-color: #f5f5f5;
    padding: 10px;
    word-break: break-all;
}

.msgBottom {
    position: absolute;
    bottom: -0.2rem;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.4rem;
}
</style>
<style>
.messages .el-pager li {
    min-width: 20px !important;
    color: #999 !important;
    background: transparent !important;
    opacity: 0.8;
}
.messages .el-pager li.active {
    color: #ff3a2b !important;
}
.messages .el-pager li:hover {
    color: #ff3a2b !important;
}
.messages .el-pagination button:hover {
    color: #ff3a2b !important;
}
.messages .el-pagination .btn-prev,
.messages .el-pagination .btn-next {
    background: transparent !important;
}
.messages .el-pagination button:disabled {
    color: #c0c4cc !important;
    background: transparent !important;
}
</style>